import { render, staticRenderFns } from "./LoginFooter.vue?vue&type=template&id=f734a160&scoped=true&"
import script from "./LoginFooter.vue?vue&type=script&lang=js&"
export * from "./LoginFooter.vue?vue&type=script&lang=js&"
import style0 from "./LoginFooter.vue?vue&type=style&index=0&id=f734a160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f734a160",
  null
  
)

export default component.exports